// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1Zul_","Logo":"Auth_Logo__bDQOU"};